/* eslint-disable-next-line  no-unused-vars */
import React, { createElement, useEffect, useRef, useState, useCallback } from 'react';
import mapConfigHelper from '../helper/mapConfigHelper';
import MapContextProvider from './MapContextProvider';
import appModes from '../helper/appModes';
import { LogService } from '../firebase/LogService';
import { v4 as uuidv4 } from 'uuid';

/*global google*/
export default function MapComponent({ callbackFunc, mapOptions, children }) {
    const mapRef = useRef();

    const [googleMap, setGoogleMap] = useState();
    const [pegmanEvent, setPegmanEvent] = useState(false);

    const mapHelper = new mapConfigHelper(mapOptions);

    const logService = new LogService();

    const { FullScreenControl, RotateControl, MapTypeControl, ZoomControl, StreetViewControl, Draggable, Scrollwheel } =
        appModes(mapOptions);

    useEffect(() => {
        (async () => {
            const opt = (google.maps.MapOptions = {
                center: mapHelper.getMapCenter(),
                fullscreenControl: FullScreenControl,
                fullscreenControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                zoom: mapHelper.getZoom(),
                tilt: 45,
                mapTypeControl: MapTypeControl,
                zoomControl: ZoomControl,
                streetViewControl: StreetViewControl,
                draggable: Draggable,
                // gestureHandling: "none"
                scrollwheel: Scrollwheel,
                rotateControl: RotateControl,
                rotateControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                },
                mapTypeId: mapHelper.getMapType(),
                styles: [
                    {
                        featureType: 'poi',
                        stylers: [{ visibility: 'off' }]
                    },
                    {
                        featureType: 'transit',
                        stylers: [{ visibility: 'off' }]
                    },
                    {
                        featureType: 'administrative.province',
                        elementType: 'geometry.stroke',
                        stylers: [ { "color": "#000" }, { "saturation": -100 }, { weight: 2 }]
                    }
                ]
            });

            if (mapOptions.Enable3DMode) {
                opt.mapId = mapOptions.MapId;
                delete opt.mapTypeId;
                delete opt.styles;
            } else {
                delete opt.mapId;
            }

            const gMap = new google.maps.Map(mapRef.current, opt);

            if (StreetViewControl) {
                gMap.getStreetView().setOptions({
                    imageDateControl: true
                });

                let panorama = gMap.streetView;
                panorama.addListener('position_changed', () => {
                    let pos = panorama.getPosition();
                    pos = { lat: pos.lat(), lng: pos.lng() };
                    panorama.lastPosition = pos;
                    pegmanClickFunc(gMap);
                    // setStreetViewPosition({ ...pos });
                });
            }

            gMap.isFractionalZoomEnabled = true;
            setDataStyle(gMap);

            //todo: to access map on console, will remove then.
            window.initMap = gMap;
            setGoogleMap(gMap);
            // logService.addDocument({
            //     time: new Date().getTime(),
            //     id: uuidv4(),
            //     type:"map_render"
            // })
        })();
    }, []);


    useEffect(() => {
        if (googleMap) {
            callbackFunc ? callbackFunc(googleMap) : null;
        }
    }, [googleMap]);

    // window.gm_authFailure = (e, b, c) => {
    // }

    const pegmanClickFunc = (map) => {
        if (!pegmanEvent) {
            let divCollection = document.getElementsByClassName('gm-svpc');
            let divItem;
            if (divCollection) divItem = divCollection[0];

            if (divItem && divItem.title.includes('Pegman')) {
                setPegmanEvent(true);
                divItem.onclick = () => {
                    if (map.streetView.lastPosition) {
                        let panorama = map.streetView;
                        // panorama.setPosition(streetViewPosition);
                        panorama.setVisible(true);
                    }
                };
            }
        }
    };

    const setDataStyle = (map) => {
        map.data.setStyle(function (feature) {
            let styleOpt = {};

            if (feature.getProperty('icon')) {
                let icon = {};
                icon.url = feature.getProperty('icon');

                if (feature.getProperty('icon-color')) icon.color = feature.getProperty('icon-color');

                styleOpt.icon = icon;
            }

            if (feature.getProperty('label')) {
                let label = {};
                label.text = feature.getProperty('label');

                if (feature.getProperty('label-color')) label.color = feature.getProperty('label-color');
                styleOpt.label = label;
            }

            if (feature.getProperty('stroke')) styleOpt.strokeColor = feature.getProperty('stroke');

            if (feature.getProperty('stroke-opacity')) styleOpt.strokeOpacity = feature.getProperty('stroke-opacity');

            if (feature.getProperty('stroke-width')) styleOpt.strokeWeight = feature.getProperty('stroke-width');

            if (feature.getProperty('fill')) styleOpt.fillColor = feature.getProperty('fill');

            if (feature.getProperty('zIndex')) styleOpt.zIndex = feature.getProperty('zIndex');

            if (feature.getProperty('fill-opacity')) styleOpt.fillOpacity = feature.getProperty('fill-opacity');
            else styleOpt.fillOpacity = 0.9;

            return styleOpt;
        });
    };

    return (
        <>
            <div ref={mapRef} className="map" id="gisMap" />

            <MapContextProvider map={googleMap}>{googleMap ? children : <></>}</MapContextProvider>
        </>
    );
}
